import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './../pages/Home';
import Tours from './../pages/Tours';
import TourDetails from './../pages/TourDetails';
import About from '../pages/About';
import SearchResultList from './../pages/SearchResultList';
import ThankYou from '../pages/ThankYou';
import TermsOfUse from '../pages/TermsOfUse';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import FAQ from '../pages/FAQ';
import ContactUs from '../components/Contact/ContactUs';
import TourPackages from '../pages/TourPackages';
// import SouthIndiaTour from '../pages/tour page/SouthIndiaTour';
import CarRental from '../pages/CarRental';
import Destinations from '../pages/Destinations';
import Jaipur from '../pages/places/JaipurTour';
import Bikaner from '../pages/places/Bikaner';
import Jaisalmer from '../pages/places/Jaisalmer';
import Ajmer from '../pages/places/Ajmer';
import Barmer from '../pages/places/Barmer';
import Bharatpur from '../pages/places/Bharatpur';
import Bhilwara from '../pages/places/Bhilwara';
import Bundi from '../pages/places/Bundi';
import Chittogarh from '../pages/places/Chittogarh';
import Dholpur from '../pages/places/Dholpur';
import Dungarpur from '../pages/places/Dungarpur';
import JaipurTour from '../pages/places/JaipurTour';
import Jhalawpur from '../pages/places/Jhalawpur';
import Jodhpur from '../pages/places/Jodhpur';
import Karauli from '../pages/places/Karauli';
import Kumbhalpur from '../pages/places/Kumbhalpur';
import MountAbu from '../pages/places/MountAbu';
import Ranakpur from '../pages/places/Ranakpur';
import Ranthambore from '../pages/places/Ranthambore';
import Shekhawati from '../pages/places/Shekhawati';
import Udaipur from '../pages/places/Udaipur';
import ThankYouContact from '../pages/ThankYouContact';
// import Blogs from '../pages/Blogs';
import Blogs from '../pages/Blogs';
import CharDhamYatra from '../pages/blogs/CharDhamYatra';
import KedarnathBadrinath1 from '../pages/blogs/KedarnathBadrinath';
import GoldenTourPackagesBlog from '../pages/blogs/GoldenTourPackagesBlog';
import DelhiSightSeeing from '../pages/blogs/DelhiSightSeeing';
import RajasthanBlog from '../pages/blogs/RajasthanBlog';
import JaisalmerBlog from '../pages/blogs/JaisalmerBlog';
import Breadcrumb from '../components/Breadcrumb/Breadcrumb';
import GoldenTriangleTourRanthamboreBlog from '../pages/blogs/GoldenTraingleTourRanthamboreBlog';
import JaipurSightseeing from '../pages/tour page/samedaytours/JaipurSightseeing';
import MainSameDay from '../pages/tour page/samedaytours/MainSameDay';
import JaipurVillage from '../pages/tour page/samedaytours/JaipurVillage';
import NightOpenJaipur from '../pages/tour page/samedaytours/NightOpenJaipur';
import MainRajasthanTravel from '../pages/places/MainRajasthanTravel';
import PlanJaipur from '../pages/blogs/PlanJaipur';
import OneDayJaipur from '../pages/blogs/OneDayJaipur';


const Router = () => {
  const location = useLocation();

  // Function to scroll to the top of the page
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  // Scroll to the top whenever the location changes
  useEffect(() => {
    scrollToTop();
  }, [location]);
  const isHomePage = location.pathname === '/';

  return (
    <>
    {!isHomePage && <Breadcrumb />}
    <Routes>
      <Route path='/' element={<Home/>} />
      <Route path='/about-us' element={<About />} />
      <Route path='/blogs' element={<Blogs />} />
      <Route path='/tours' element={<Tours />} />
      <Route path='/tours/:id' element={<TourDetails />} />
      <Route path='/tour-packages' element={<TourPackages />} />
      <Route path='/thank-you' element={<ThankYou />} />
      <Route path='/thank-you-contact' element={<ThankYouContact/>} />
      <Route path='/terms-of-use' element={<TermsOfUse />} />
      <Route path='/privacy-policy' element={<PrivacyPolicy />} />
      <Route path='/contact-us' element={<ContactUs />} />
      <Route path='/faq' element={<FAQ />} />
      <Route path='/tours/search' element={<SearchResultList />} />
      <Route path='/tour-packages/jaipur-tour-packages/' element={<MainSameDay />} />
      <Route path='/destinations/Rajasthan' element={<MainRajasthanTravel />} />




      <Route path='/tour-packages/jaipur-tour-packages/jaipur-sightseeing-day-tour' element={<JaipurSightseeing/>} />
      <Route path='/tour-packages/jaipur-tour-packages/jaipur-jeep-safari' element={<JaipurVillage/>} />
      <Route path='/tour-packages/jaipur-tour-packages/open-air-night-tour-of-jaipur-city' element={<NightOpenJaipur/>} />
      




      <Route path='/car-rental' element={<CarRental />} />
      <Route path='/destinations/' element={<Destinations />} />
      <Route path='/destinations/Rajasthan/ajmer' element={<Ajmer/>} />
      <Route path='/destinations/Rajasthan/barmer' element={<Barmer/>} />
      <Route path='/destinations/Rajasthan/bharatpur' element={<Bharatpur/>} />
      <Route path='/destinations/Rajasthan/bhilwara' element={<Bhilwara/>} />
      <Route path='/destinations/Rajasthan/bundi' element={<Bundi/>} />
      <Route path='/destinations/Rajasthan/chittorgarh' element={<Chittogarh/>} />
      <Route path='/destinations/Rajasthan/dholpur' element={<Dholpur/>} />
      <Route path='/destinations/Rajasthan/dungarpur' element={<Dungarpur/>} />
      <Route path='/destinations/Rajasthan/jaipur' element={<JaipurTour/>} />
      <Route path='/destinations/Rajasthan/jaipur' element={<Jaipur/>} />
      <Route path='/destinations/Rajasthan/jhalawpur' element={<Jhalawpur/>} />
      <Route path='/destinations/Rajasthan/jodhpur' element={<Jodhpur/>} />
      <Route path='/destinations/Rajasthan/karauli' element={<Karauli/>} />
      <Route path='/destinations/Rajasthan/kumbhalpur' element={<Kumbhalpur/>} />
      <Route path='/destinations/Rajasthan/karauli' element={<Karauli/>} />
      <Route path='/destinations/Rajasthan/mount-abu' element={<MountAbu/>} />
      <Route path='/destinations/Rajasthan/ranakpur' element={<Ranakpur/>} />
      <Route path='/destinations/Rajasthan/ranthambore' element={<Ranthambore/>} />
      <Route path='/destinations/Rajasthan/shekhawati' element={<Shekhawati/>} />
      <Route path='/destinations/Rajasthan/bikaner' element={<Bikaner/>} />
      <Route path='/destinations/Rajasthan/jaisalmer' element={<Jaisalmer/>} />
      <Route path='/destinations/Rajasthan/udaipur' element={<Udaipur/>} />

      {/*=========== Our Blogs =====================*/}
      <Route path="/blogs/embarking-on-a-divine-quest:-exploring-the-char-dham-yatra-in-2024" element={<CharDhamYatra/>} />
      <Route path="/blogs/embark-on-a-spiritual-journey:-discover-the-divine-essence-of-kedarnath-and-badrinath" element={<KedarnathBadrinath1/>} />
      <Route path="/blogs/uncover-the-majestic-beauty-of-india-with-golden-triangle-tour-packages" element={<GoldenTourPackagesBlog/>} />
      <Route path="/blogs/essential-things-to-carry-for-your-delhi-sightseeing-tour" element={<DelhiSightSeeing/>} />
      <Route path="/blogs/exploring-unforgettable-experience-rajasthan-tour" element={<RajasthanBlog/>} />
      <Route path="/blogs/golden-city-best-time-to-visit-jaisalmer" element={<JaisalmerBlog/>} />
      <Route path="/blogs/epic-adventure-the-golden-triangle-tour-with-ranthambore" element={<GoldenTriangleTourRanthamboreBlog/>} />
      <Route path="/blogs/how-to-plan-a-perfect-one-day-trip-to-jaipur:-a-complete-guide" element={<PlanJaipur/>} />
      <Route path='/blogs/what-can-you-do-in-jaipur-for-a-full-day-the-rustic-paths-perspective' element={<OneDayJaipur/>} />
    </Routes>
    </>
  );
}

export default Router;
